/**
 * Route paths for account deletion public pages.
 */
export const ACCOUNT_DELETION_ROUTES = {
  REQUEST: '/request-account-deletion',
  VERIFICATION: '/account-deletion',
};

/**
 * API endpoint paths (relative to REACT_APP_BASE_URL).
 */
export const ACCOUNT_DELETION_API_ENDPOINTS = {
  REQUEST: '/api/v1/request-account-deletion/',
  VERIFICATION: '/api/v1/account-deletion-verification/',
};

/**
 * Query string key for the verification token from the email link.
 */
export const ACCOUNT_DELETION_QUERY_PARAMS = {
  TOKEN: 'token',
};

/**
 * Backend account deletion request status values.
 */
export const ACCOUNT_DELETION_REQUEST_STATUS = {
  RECEIVED: 'RECEIVED',
  VERIFIED: 'VERIFIED',
  COMPLETED: 'COMPLETED',
};

/**
 * Token expiry duration communicated to the user (minutes), aligned with backend.
 */
export const ACCOUNT_DELETION_TOKEN_EXPIRY_MINUTES = 30;

/**
 * Page copy and UI labels.
 */
export const ACCOUNT_DELETION_PAGE_COPY = {
  REQUEST_TITLE: 'Request account deletion',
  REQUEST_DESCRIPTION:
    'Enter the email address associated with your Purebrand account. We will send you a verification link to confirm this request.',
  REQUEST_EXPIRY_NOTE: `The verification link expires after ${ACCOUNT_DELETION_TOKEN_EXPIRY_MINUTES} minutes.`,
  REQUEST_SUBMIT_BUTTON: 'Submit request',
  REQUEST_SUCCESS_TITLE: 'Check your email',
  REQUEST_SUCCESS_MESSAGE:
    'If an account deletion request was submitted for this email, you will receive a verification link shortly. Please open the link to confirm your request.',
  VERIFICATION_PAGE_TITLE: 'Verify account deletion',
  VERIFICATION_LOADING: 'Verifying your account deletion request...',
  VERIFICATION_SUCCESS_TITLE: 'Request verified',
  VERIFICATION_ALREADY_VERIFIED_TITLE: 'Already verified',
  VERIFICATION_MISSING_TOKEN: 'Verification link is invalid or missing a token.',
  VERIFICATION_GO_HOME: 'Go to login',
  RETURN_TO_LOGIN_PREFIX: 'Want to go back?',
  RETURN_TO_LOGIN_LINK: 'Click me!',
  EMAIL_PLACEHOLDER: 'Enter email',
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Invalid email address format',
};

/**
 * API response messages returned by the backend (keep in sync with accounts/constants.py).
 */
export const ACCOUNT_DELETION_API_RESPONSE_MESSAGES = {
  REQUEST_CREATED:
    'Your account deletion request has been received. Please check your email to verify the request.',
  VERIFICATION_SUCCESS:
    'Your account deletion request has been verified successfully.',
  ALREADY_VERIFIED: 'This account deletion request has already been verified.',
  ALREADY_COMPLETED: 'This account deletion request has already been completed.',
  INVALID_TOKEN: 'Invalid or expired verification token.',
};

/**
 * Generic and API-driven error fallbacks.
 */
export const ACCOUNT_DELETION_ERROR_MESSAGES = {
  GENERIC: 'Something went wrong. Please try again later.',
  REQUEST_FAILED: 'Unable to submit your account deletion request. Please try again.',
  VERIFICATION_FAILED: 'Unable to verify your account deletion request. Please try again.',
  MISSING_TOKEN: ACCOUNT_DELETION_PAGE_COPY.VERIFICATION_MISSING_TOKEN,
};

/**
 * Navigation paths used by account deletion flows.
 */
export const ACCOUNT_DELETION_NAVIGATION = {
  LOGIN: '/login',
};
